import React from "react";
import { AnimatePresence } from "framer-motion";
import { PopupContainer } from "@/components/layout/PopupContainer";
import { useActiveOverlay, useCashHistory, useDepotHistory, useStats } from "@/state/selectors";
import { useGameStore } from "@/state/gameStore";
import { OverlayType } from "@/types/state";
import AccountDetails from "@/components/screens/PlayingScreen/components/AccountOverviewPanel/AcountDetails/AccountDetails";

interface FundDetailsProps {
    onClose?: () => void;
}

export const AccountOverviewPanel: React.FC<FundDetailsProps> = ({ onClose }) => {
    const activeOverlay = useActiveOverlay();
    const stats = useStats();
    const cashHistory = useCashHistory();
    const depotHistory = useDepotHistory();
    const setOverlay = useGameStore((state) => state.setOverlay);

    const isOpen = activeOverlay === OverlayType.Stats;

    const handleClose = () => {
        setOverlay(OverlayType.None);
    };

    const handleExitComplete = () => {
        onClose?.();
    };

    return (
        <AnimatePresence onExitComplete={handleExitComplete}>
            {isOpen && (
                <PopupContainer
                    key="account-overview-popup"
                    onClick={(e: React.MouseEvent) => e.stopPropagation()}
                    title="Finanzüberblick"
                    onClose={handleClose}
                >
                    <div className="flex flex-col justify-center items-start gap-2 w-full pb-6">
                        <AccountDetails accountHistory={cashHistory} balance={stats.cash} type="cash" />
                        <AccountDetails accountHistory={depotHistory} balance={stats.investments} type="depot" />
                    </div>
                </PopupContainer>
            )}
        </AnimatePresence>
    );
};

export default AccountOverviewPanel;